import { useMediaQuery, useTheme } from "@mui/material";

export const useScreenSize = () => {
  const theme = useTheme();

  // Refer MUI for breakpoints - https://mui.com/material-ui/customization/breakpoints/
  const belowWideDesktop = useMediaQuery(theme.breakpoints.down("xl")); //1536px
  const belowDesktop = useMediaQuery(theme.breakpoints.down("lg")); //1200px
  const belowTablet = useMediaQuery(theme.breakpoints.down("md")); //900px
  const belowPhablet = useMediaQuery(theme.breakpoints.down("sm")); //600px

  return {
    belowWideDesktop: belowWideDesktop,
    belowDesktop: belowDesktop,
    belowTablet: belowTablet,
    belowPhablet: belowPhablet,
  };
};
